export default __webpack_public_path__ + "static/media/pina_colada_slushie_thumbnail.35e7ff4d.JPG";